import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  createDeerFlowInstanceThread,
  deleteDeerFlowInstanceThread,
  generateDeerFlowInstances,
  getDeerFlowInstanceAgents,
  getDeerFlowInstanceThreads,
  getDeerFlowThreadMessages,
  postDeerFlowThreadMessage,
} from "./actions";
import { DeerFlowState } from "./types";

export function generateDeerFlowInstancesReducerBuilder(
  builder: ActionReducerMapBuilder<DeerFlowState>,
) {
  builder.addCase(generateDeerFlowInstances.pending, (state) => {});
  builder.addCase(generateDeerFlowInstances.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.deerFlowInstances = action.payload;
  });
  builder.addCase(generateDeerFlowInstances.rejected, (state) => {});
}

export function getDeerFlowInstanceAgentsReducerBuilder(
  builder: ActionReducerMapBuilder<DeerFlowState>,
) {
  builder.addCase(getDeerFlowInstanceAgents.pending, (state) => {});
  builder.addCase(getDeerFlowInstanceAgents.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.instanceAgents = action.payload.agents;
  });
  builder.addCase(getDeerFlowInstanceAgents.rejected, (state) => {});
}

export function getDeerFlowInstanceThreadsReducerBuilder(
  builder: ActionReducerMapBuilder<DeerFlowState>,
) {
  builder.addCase(getDeerFlowInstanceThreads.pending, (state) => {});
  builder.addCase(getDeerFlowInstanceThreads.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.instanceThreads = action.payload;
  });
  builder.addCase(getDeerFlowInstanceThreads.rejected, (state) => {});
}

export function createDeerFlowInstanceThreadReducerBuilder(
  builder: ActionReducerMapBuilder<DeerFlowState>,
) {
  builder.addCase(createDeerFlowInstanceThread.pending, (state) => {});
  builder.addCase(createDeerFlowInstanceThread.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.instanceThreads = [...state.instanceThreads, action.payload];
    state.selectedInstanceThread = action.payload;
  });
  builder.addCase(createDeerFlowInstanceThread.rejected, (state) => {});
}

export function deleteDeerFlowInstanceThreadReducerBuilder(
  builder: ActionReducerMapBuilder<DeerFlowState>,
) {
  builder.addCase(deleteDeerFlowInstanceThread.pending, (state) => {});
  builder.addCase(deleteDeerFlowInstanceThread.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.instanceThreads = state.instanceThreads.filter(
      (thread) => thread.thread_id !== action.payload,
    );
    state.selectedInstanceThread = null;
    state.messages = [];
  });
  builder.addCase(deleteDeerFlowInstanceThread.rejected, (state) => {});
}

export function getDeerFlowThreadMessagesReducerBuilder(
  builder: ActionReducerMapBuilder<DeerFlowState>,
) {
  builder.addCase(getDeerFlowThreadMessages.pending, (state) => {
    state.isMessageLoading = true;
  });
  builder.addCase(getDeerFlowThreadMessages.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.messages = action.payload;
    state.isMessageLoading = false;
  });
  builder.addCase(getDeerFlowThreadMessages.rejected, (state) => {
    state.isMessageLoading = false;
  });
}

export function postDeerFlowThreadMessageReducerBuilder(
  builder: ActionReducerMapBuilder<DeerFlowState>,
) {
  builder.addCase(postDeerFlowThreadMessage.pending, (state) => {
    state.isMessageLoading = true;
  });
  builder.addCase(postDeerFlowThreadMessage.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.messages = [...state.messages, action.payload];
    state.isMessageLoading = false;
  });
  builder.addCase(postDeerFlowThreadMessage.rejected, (state) => {
    state.isMessageLoading = false;
  });
}
